// extracted by mini-css-extract-plugin
export default {"containerVerticalStepper":"stepper-styles_containerVerticalStepper__4ganN","verticalStepperSxElement":"stepper-styles_verticalStepperSxElement__Ezh+c"};